export default "__VITE_PUBLIC_ASSET__62cb5932__"